import * as React from 'react';
import styled from 'styled-components';

const CheckBox = (props: Props) => {
	const handleChange = () => props.onChange(props.name, !props.value);
	return (
		<>
			<CheckBoxInput
				type="checkbox"
				checked={props.value}
				name={props.name}
				onChange={handleChange}
				disabled={props.disabled}
				hide={props.hidden}
			/>
			{props.label && (
				<label htmlFor={props.name} onClick={props.disabled || props.hidden ? null : handleChange}>
					{props.label}
				</label>
			)}
		</>
	);
};

interface Props {
	label?: string;
	value: boolean;
	onChange: (name: string, value: boolean) => void;
	name: string;
	disabled?: boolean;
	hidden?: boolean;
}

CheckBox.defaultProps = {
	label: null,
	disabled: false,
	hidden: false
};

const CheckBoxInput = styled.input<{ hide: boolean }>`
	width: 20px;
	height: 20px;
	font-size: 20px;
	line-height: 20px;
	padding-left: 26px;
	margin-right: 5px;
	color: #262626;
	vertical-align: top;
	cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
	&::before {
		background-color: '#19419b';
		border-color: '#19419b';
		box-shadow: '0 0 0 2px rgba(21, 137, 238, 0.3)';
	}
	${(props) => (props.hide ? 'visibility: hidden;' : '')}
`;

export default CheckBox;
